import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BsArrowUpRight, BsArrowDownRight } from 'react-icons/bs'; 
import './FAQSection.css';

// --- ASSETS ---
import arrowDoodle from '../../../assets/About/Acc.png'; 

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const services = [
    {
      id: 1,
      title: '(1) Alignment',
      description: 'We begin by aligning your vision, objectives, and brand intent. This step helps us clearly define what success looks like and ensures every decision moving forward serves a clear purpose.'
    },
    {
      id: 2,
      title: '(2) CREATION',
      description: 'Once the strategy is set, we move to creation. This involves crafting the visual identity, messaging, and digital assets that bring your brand personality to life across all touchpoints.'
    },
    {
      id: 3,
      title: '(3) ACTIVATION',
      description: 'The final phase is activation. We launch your brand into the world with targeted campaigns, digital experiences, and marketing strategies designed to engage your audience and drive growth.'
    }
  ];

  return (
    <section className="faq-section">
      <Container className="position-relative">
        
        {/* Added 'align-items-start' to ensure Title and List start at the same Y position */}
        <Row className="align-items-start">
          
          {/* --- LEFT COLUMN: TITLE --- */}
          <Col lg={5} md={12} className="faq-title-col position-relative">
            <h2 className="faq-title">
            Our Approach <br />
              to Building 
               <br />
                Brands
            </h2>
            
            {/* Arrow positioned relative to this column or the row */}
            <div className="arrow-doodle-wrapper d-none d-lg-block">
               <img src={arrowDoodle} alt="arrow pointing" className="doodle-img" />
            </div>
          </Col>

          {/* --- RIGHT COLUMN: ACCORDION LIST --- */}
          <Col lg={6} md={12} className="offset-lg-1 faq-list-col">
            <div className="faq-list">
              {services.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div 
                    key={item.id} 
                    className={`faq-item ${isOpen ? 'open' : ''}`}
                    onClick={() => toggleItem(index)}
                  >
                    <div className="faq-header">
                      <span className="faq-item-title">{item.title}</span>
                      <span className="faq-icon">
                        {isOpen ? <BsArrowDownRight /> : <BsArrowUpRight />}
                      </span>
                    </div>

                    <div 
                      className="faq-content"
                      style={{ 
                        maxHeight: isOpen ? '200px' : '0px',
                        opacity: isOpen ? 1 : 0
                      }}
                    >
                      <p>{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;